// Vuetify
// @ts-ignore
import colors from 'vuetify/lib/util/colors';
// lodash
import { fill, merge } from 'lodash';
// ECharts
// @ts-ignore
import echarts from 'echarts';
// Util
import getImgBase64FromURL from '../commons/base64imgfromurl';
// Interfaces
import { IUsers } from '../interfaces/commons/IUsers';
import { ISchool } from '../interfaces/commons/ISchool';
// PDF
// @ts-ignore
import pdfMake from 'pdfmake/build/pdfmake';
// @ts-ignore
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { interBoldBase64 } from './interBold';
import { interRegularBase64 } from './interRegular';
pdfMake.vfs= pdfFonts.pdfMake.vfs;
pdfMake.vfs['Inter-Regular.ttf'] = interRegularBase64;
pdfMake.vfs['Inter-Bold.ttf'] = interBoldBase64;
pdfMake.fonts = {
  Inter:{
    normal: 'Inter-Regular.ttf',
    bold: 'Inter-Bold.ttf',
  }
}

interface ImageReports {
  IMG_BACKGROUND_HEADER: string;
  IMG_LOGO: string;
  // IMG_INSTITUTION: string;
}

interface CustomizeTable {
  tableContent: any;
  id?: string | number;
  layout?: object | null | undefined;
  style?: string[] | null | undefined;
  otherProperties?: object | null | undefined;
}

// Configuración de dimensiones
const PAGE_MARGIN: number = 20;
const IMG_HEADER_HEIGHT: number = 75;
const IMG_FOOTER_HEIGHT: number = 20;

// Colors
// Light Colors
const generalTitleColor: string = colors.grey.lighten2;
const lightGreenColor: string = colors.green.lighten4;
const lightRedColor: string = colors.red.lighten4;
const veryLightOrangeColor: string = colors.orange.lighten4;
const lightFirstColumnColor: string = colors.orange.lighten3;
const lightSecondColumnColor: string = colors.lightBlue.lighten4;
const lightThirdColumnColor: string = colors.purple.lighten4;
const lightFourthColumnColor: string = colors.yellow.lighten3;
// Darker Light Colors
const darkerLightFirstColumnColor: string = colors.orange.lighten1;
const darkerLightSecondColumnColor: string = colors.lightBlue.lighten1;
const darkerLightThirdColumnColor: string = colors.purple.lighten1;
const darkerLightFourthColumnColor: string = colors.yellow.lighten1;
// Darker Colors
const darkerOrangeColor: string = colors.orange.darken4;
// Charts Colors
const darkBarChartColor: string = colors.blue.darken1;

/* tslint:disable:curly */

abstract class BaseReport {

  public static getGeneralEchartInstance(chartHeight: number, chartWidth: number) {
    const canvas: HTMLCanvasElement = document.createElement('canvas');
    canvas.width = chartWidth;
    canvas.height = chartHeight;

    return echarts.init(canvas, '', {
      width: chartWidth,
      height: chartHeight,
    });
  }

  public static buildChart(chartHeight: number, chartWidth: number, options: any): string {
    const chart = BaseReport.getGeneralEchartInstance(chartHeight, chartWidth);
    chart.setOption({
      animation: false,
      grid: {
        top: 10,
        bottom: 20,
        left: 'center',
        width: '90%',
        containLabel: true,
      },
      ...options,
    });
    return chart.getDataURL({
      type: 'jpeg',
      backgroundColor: 'white'
    });
  }

  public static pageBreak(order: string): Array<{ text: string, pageBreak: string }> {
    return [{ text: '', pageBreak: order }];
  }

  public user: IUsers;
  public school: ISchool;
  public logoURL: string;
  public dataToReport: any;
  public testing: boolean = false;
  public documentHeight: number = 842;
  public documentWidth: number = 595;

  constructor(user: IUsers, school: ISchool, dataToReport: any, logoURL: string) {
    this.user = user;
    this.school = school;
    this.dataToReport = dataToReport;
    this.logoURL = `https://plataforma.romacl.com/LogoInstitucion?id=${school.logo}`;
  }

  public abstract async downloadReport(): Promise<any>;

  public async buildBaseReport(baseProperties: any) {
    const { IMG_BACKGROUND_HEADER, IMG_LOGO } = await this.buildImages();
    const {
      firstTitle,
      secondTitle,
      reportTitle,
      pageOrientation = 'portrait',
    } = baseProperties;
    const isPortait = pageOrientation == 'portrait';
    const self = this;
    let titles: any[] = [{
      onPage: 1,
      title: this.dataToReport && this.dataToReport.data && this.dataToReport.data.length > 0? this.dataToReport.data[0].unit + ' - ' + this.dataToReport.data[0].name: 'No Aplica',
    }];
    let unitCurrentIndex = 1;
    const baseDocDefinition: any = {
      pageSize: {
        width: this.documentWidth,
        height: this.documentHeight,
      },
      // pageOrientation: 'landscape',
      pageOrientation,
      pageMargins: [
        PAGE_MARGIN,
        isPortait? (PAGE_MARGIN + IMG_HEADER_HEIGHT - 10) : (PAGE_MARGIN + IMG_HEADER_HEIGHT + 10),
        PAGE_MARGIN,
        (isPortait? IMG_FOOTER_HEIGHT + 4: IMG_FOOTER_HEIGHT + 6),
      ],
      /*
      background: (currentPage: any, pageSize: any) => {
        return {
          id: 'img_bg',
          image: 'IMG_BACKGROUND_HEADER',
          width: pageSize.width,
          height: IMG_HEADER_HEIGHT,
          margin: [0, 0, 0, 0],
        };
      },*/
      
      header: function(currentPage, pageCount, pageSize){
        let headerBody: any[] = [
          [
            {
              image: IMG_LOGO,
              width: 30,
              rowSpan: 2,
              margin: [5, 17, 0, 15], //institutionLogoBase64? [-17, -5, 0, 0]:[-12, 5, 0, 0],
              border: [false, false, false, false],
            },
            { 
              text: `${self.capitalizeText(self.school.name)}`, 
              margin: [0, 10, 0, 0], 
              colSpan: 3, 
              style: ['titulo5', 'colorNeutralBlack'],
              border: [false, false, false, false],
            }, 
            {
              text: '', 
              border: [false, false, false, false],
            },
            {
              text: '', 
              border: [false, false, false, false],
            },
            { text: `${self.capitalizeText(firstTitle)}`, 
              alignment: 'right', 
              margin: [0, 10, 0, 0], 
              style: ['titulo4', 'colorNeutralBlack'],
              border: [false, false, false, false],
            }
          ], [
            {
              text: '',
              margin: [5, 0, 0, 0],
              border: [false, false, false, false],
            },
            {
              text: `${self.capitalizeText(reportTitle)}`, 
              style: ['titulo6', 'colorNeutralBlack'],
              margin: [0, -3, 0, 0],
              colSpan: 3,
              bold: true,
              border: [false, false, false, false],
            },
            {
              text: '',
              style: ['titulo6', 'colorNeutralBlack'],
              bold: true,
              border: [false, false, false, false],
            },
            {
              text: '',
              border: [false, false, false, false],
            },
            {
              text: `${self.capitalizeText(secondTitle)}`,
              alignment: 'right',
              margin: [0, -3, 0, 0],
              bold: true,
              style: ['titulo6', 'colorNeutralBlack'],
              border: [false, false, false, false],
            },
          ],
        ];

        if(self.dataToReport && self.dataToReport.data && self.dataToReport.data.length > 0){
          let headerTitle = [...titles].reverse().find((element: any) => element.onPage <= currentPage);

          headerBody.push([
            {
              text: headerTitle? headerTitle.title: 'No se consiguió unidad', //`${self.dataToReport.data[0].unit} - ${self.dataToReport.data[0].name}`,
              colSpan: 4,
              style: ['titulo6', 'colorNeutralBlack'],
              margin: [0, 7, 0, 5],
              borderColor: ['#D8D7D9', '#D8D7D9', '#D8D7D9', '#D8D7D9'],
              border: [false, true, false, false],
            },
            { 
              text: '',
              borderColor: ['#D8D7D9', '#D8D7D9', '#D8D7D9', '#D8D7D9'],
              border: [false, true, false, false],
            },
            { 
              text: '',
              borderColor: ['#D8D7D9', '#D8D7D9', '#D8D7D9', '#D8D7D9'],
              border: [false, true, false, false],
            },
            { 
              text: '',
              borderColor: ['#D8D7D9', '#D8D7D9', '#D8D7D9', '#D8D7D9'],
              border: [false, true, false, false],
            },
            {
              text: `${self.dataToReport.data[0].hours} horas | ${self.user.fullName}`,
              alignment: 'right',
              style: ['titulo6', 'colorNeutralBlack'],
              margin: [0, 7, 0, 5],
              borderColor: ['#D8D7D9', '#D8D7D9', '#D8D7D9', '#D8D7D9'],
              border: [false, true, false, false],
            },
          ]);
        }
        return {
          margin: [PAGE_MARGIN, 0, PAGE_MARGIN, 0],
          fillColor: '#F8F8F8',
          table:{
            widths: ['*'],
            fillColor: '#F8F8F8',
            
            body: [
              [{
                borderColor: ['#D8D7D9', '#D8D7D9', '#D8D7D9', '#D8D7D9'],
                border: [true, true, true, true],
                margin: [10, 0, 10, 0],
                table: {
                  layout: 'noBorders',
                  widths:  [40, '*', 10, 10, 300],
                  headerRows: 2,
                  fillColor: '#F8F8F8',
                  margin: [10, 0, 0, 10],
                  body: headerBody,
                },
              }]
            ]
          }
        }
          
      },
      pageBreakBefore: (currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) => {
        if(currentNode.style && currentNode.style.includes('pageBreak') && currentNode.style.includes('startUnitPlan') && currentNode.startPosition.pageNumber > 1){
          const applyToPage = currentNode.startPosition.pageNumber + 1;
          titles.push({
            onPage: applyToPage,
            title: self.dataToReport.data[unitCurrentIndex].unit + ' - ' + self.dataToReport.data[unitCurrentIndex].name,
          });
          unitCurrentIndex++;
          return true;
        }
        return false;
      },
      images: {
        IMG_LOGO,
        IMG_BACKGROUND_HEADER,
      },
      styles: {
        tableElement: {
          fontSize: 10,
          alignment: 'justify',
          margin: [0, 0, 0, 10],
        },
        reportPartTitle: {
          fillColor: generalTitleColor,
        },
        tableTitle: {
          fontSize: 10,
          alignment: 'center',
        },
        innerTableContent: {
          margin: 5,
        },
        footerItems: {
          alignment: 'center',
          fontSize: 9,
        },
        blueHeader: {
          fillColor: lightSecondColumnColor,
        },
        orangeHeader: {
          fillColor: '#fce4d6'
        },
        greenHeader: {
          fillColor: '#e2efda'
        },
        yellowHeader: {
          fillColor: '#fff2cc'
        },
        lightDarkHeader: {
          fillColor: '#F8F8F8'
        },
        noData: {
          fontSize: 12,
          margin: 5,
          alignment: 'center',
        },
        titulo2: {
          fontSize: 14.25,
          bold: true
        },
        titulo3: {
          fontSize: 12.75,
          bold: true
        },
        titulo4:{
          fontSize: 11.25,
          bold: true
        },
        titulo5: {
          fontSize: 9.75,
          bold: true,
        },
        titulo6:{
          fontSize: 8.25,
          bold: true
        },
        parrafo1: {
          fontSize: 9.75
        },
        parrafo2: {
          fontSize: 8.25,
          bold: false
        },
        parrafo3: {
          fontSize: 6.75,
          bold: false
        },
        parrafo4: {
          fontSize: 7.5,
          bold: false
        },
        parrafo5: {
          fontSize: 6,
          bold: false
        },
        ms2: {
          margin: [8, 0, 0, 0],
          padding: [10, 0, 0, 0],
        },
        colorNeutralBlack: {
          color: '#101840'
        }
      },
      defaultStyle: {
        color: '#1A161B',
        font: 'Inter',
      }
    };

    return baseDocDefinition;
  }

  public buildImages(): Promise<ImageReports> {
    return new Promise(async (resolve, reject) => {
      try {
        const IMG_BACKGROUND_HEADER: string = await getImgBase64FromURL(require('../assets/report-bg.png'));
        const IMG_LOGO: string = await getImgBase64FromURL(require('../assets/logo-roma.png'));
        // const IMG_INSTITUTION: string = await getImgBase64FromURL(this.logoURL + this.school.logo);
        resolve({
          IMG_BACKGROUND_HEADER,
          IMG_LOGO,
          // IMG_INSTITUTION,
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  public async generateReport(docDefinition: any, baseProperties: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const baseReportDef: any = await this.buildBaseReport(baseProperties);
        merge(docDefinition, baseReportDef);
        const reportPDF = pdfMake.createPdf(docDefinition);
        docDefinition.footer = this.buildGeneralFooterFunction(docDefinition, baseProperties);
        if (!baseProperties.secondTitle)
          docDefinition.header = this.buildGeneralHeaderFunction(docDefinition, baseProperties);

        // TODO descargar PDF, ya que provoca error de red al tratar de descargarlo desde la pestaña abierta
        // if (this.testing) reportPDF.open();
        // else reportPDF.download(baseProperties.reportType + '.pdf', () => 'Reporte descargado!');
        reportPDF.download(baseProperties.reportType + '.pdf', () => resolve('Reporte descargado!'));
      } catch (error) {
        console.error('Error al generar el reporte', error);
        reject(error);
      }
    });
  }

  public findDynamicHeaderAndFooterObject(docDefinition: { content: any[]; }, currentPage: number, property: string) {
    const object = docDefinition.content
      .find((element) => element.changeHeaderAndFooter && currentPage <= element.positions[0].pageNumber);
    if (!object) { return ''; }
    return JSON.parse(object.changeHeaderAndFooter)[property];
  }

  // @ts-ignore
  public buildGeneralHeaderFunction(docDefinition: { content: any[]; }, { reportTitle, firstTitle }) {
    return (currentPage: any) => {
      const secondTitle = this.findDynamicHeaderAndFooterObject(docDefinition, currentPage, 'header');
      return {
        margin: [PAGE_MARGIN + 10, PAGE_MARGIN + IMG_HEADER_HEIGHT / 4 - 5, PAGE_MARGIN + 10, 0],
        layout: 'noBorders',
        table: {
          widths: ['100%'],
          body: [
            [
              {
                fillColor: '#FFF',
                margin: 5,
                columns: [
                  {
                    alignment: 'left',
                    // width: '75%',
                    columns: [
                      // { width: 30, image:  },
                      {
                        margin: [15, 0, 0, 0],
                        stack: [
                          {
                            text: this.school.logo + ' - ' + this.school.name,
                            margin: [0, 2, 0, 10],
                          },
                          {
                            text: reportTitle,
                            bold: true,
                          },
                        ],
                      },
                    ],
                  },
                  {
                    width: 230,
                    alignment: 'right',
                    layout: {
                      hLineWidth: (i: number) => i === 1 ? 5 : 0,
                    },
                    table: {
                      tableCellPadding: 2,
                      columnGap: 4,
                      widths: ['100%'],
                      body: [
                        [
                          {
                            text: firstTitle,
                            alignment: 'center',
                            fillColor: lightFirstColumnColor,
                            borderColor: ['#FFF', '#FFF', '#FFF', '#FFF'],
                            fontSize: 10,
                          },
                        ],
                        [
                          {
                            text: secondTitle,
                            alignment: 'center',
                            fillColor: lightFirstColumnColor,
                            borderColor: ['#FFF', '#FFF', '#FFF', '#FFF'],
                            fontSize: 10,
                          },
                        ],
                      ],
                    },
                  },
                ],
              },
            ],
          ],
        },
      };
    };
  }

  // @ts-ignore
  public buildGeneralFooterFunction(docDefinition: { content: any[]; }, { reportType, emissionDate, id = null }) {
    return (currentPage: any, pageCount: any) => {
      let unitPlanId: any = null;
      if (!id) unitPlanId = this.findDynamicHeaderAndFooterObject(docDefinition, currentPage, 'footer');
      const idElement = (unitPlanId || id)
        ? {
          width: 'auto',
          style: 'footerItems',
          text: 'ID: ' + (unitPlanId ? unitPlanId : id),
          border: false,
          margin: [0, 5, 0, 0],   
        }
        : { text: '', width: 'auto' };
      const isPortait = docDefinition.pageOrientation == 'portrait';
      if(emissionDate == null){
        emissionDate = new Date().toLocaleDateString();
      };

      return {
        id: 'FOOTER',
        fillColor: '#F8F8F8',
        margin: [PAGE_MARGIN, 0, PAGE_MARGIN, 0],
        stack: [
          /*
          {
            margin: [PAGE_MARGIN, 0, PAGE_MARGIN, 0],
            table: {
              widths: ['100%'],
              body: [['']],
            },
            layout: {
              hLineWidth: (i: number) => 0,
              vLineWidth: () => 0,
              hLineColor: () => darkerOrangeColor,
            },
          },
          */
          {
            margin: [0, 0, 0, 0],
            layout: 'noBorders',
            table: {
              widths: isPortait? [70, 125, '*', 100, 100, '*']: [70, 150, '*', '*', 150, '*'],
              border: false,
              layout: {
                hLineWidth: (i: number) => 0,
                vLineWidth: () => 0,
                hLineColor: () => darkerOrangeColor,
              },
              body: [[
                { style: 'footerItems', image: 'IMG_LOGO', width: 40,  border: false, margin: [0, 6, 0, 0]},
                {
                  style: 'footerItems',
                  border: false,
                  text: 'Reporte: ' + reportType,
                  margin: [0, 5, 0, 0],
                },
                idElement,
                {
                  style: 'footerItems',
                  text: 'Usuario: ' + this.user.userName,
                  margin: [0, 5, 0, 0],
                },
                {
                  style: 'footerItems',
                  text: 'F. Emisión: ' + (emissionDate || new Date()),
                  margin: [0, 5, 0, 0],
                },
                {
                  style: 'footerItems',
                  alignment: 'right',
                  layout: 'lightHorizontalLines',
                  table: {
                    widths: ['*'],
                    body: [
                      [
                        {
                          text: 'Página ' + currentPage + ' de ' + pageCount,
                          alignment: 'right',
                          margin: [0, 3, 4, 0],
                        },
                      ],
                    ],
                  },
                },
              ],],
            },
          },
        ],
      };
    };
  }

  public bottomBorderCell(bottomLineBorderColor: string) {
    return {
      border: [false, false, false, true],
      borderColor: [false, false, false, bottomLineBorderColor],
    };
  }

  public generalTableHeader(customizeTableHeader: any) {
    const {
      headerContent,
      style
    } = customizeTableHeader;
    return {
      ...headerContent,
      alignment: 'center', 
      style: ['titulo6', 'innerTableContent', ...(style || [])],
    };
  }

  public generalTableHeaderWithBottomColoredBorder(title: string, bottomBorderColor: string, headerStyle: string) {
    return this.generalTableHeader({
      headerContent: {
        text: title,
        ...this.bottomBorderCell(bottomBorderColor),
      },
      style: [headerStyle],
    });
  }

  public generalReportPartTitle(titleElement: any) {
    return this.generalTable({
      tableContent: {
        widths: ['*'],
        body: [
          [
            this.generalTableHeader({
              headerContent: {
                ...titleElement,
              },
              style: ['reportPartTitle'],
            }),
          ],
        ],
      },
    });
  }

  public generalTable(customizeTable: CustomizeTable) {
    const {
      id,
      tableContent,
      layout,
      style,
      otherProperties,
    } = customizeTable;
    if (tableContent.body.length <= 0) {
      console.log('EMPTY TABLE CONTENT', tableContent);
      tableContent.widths = ['*'];
      tableContent.body = [
        [this.noContent()],
      ];
    }
    return {
      id,
      table: { keepWithHeaderRows: 1, headerRows: 1, ...tableContent },
      layout: {
        ...this.generalTableLayout(generalTitleColor, 3),
        ...layout,
      },
      style: ['tableElement', ...(style || [])],
      ...otherProperties,
    };
  }

  public generalTableLayout(borderColor: string, lineWidth: number) {
    return {
      hLineWidth: (i: number, node: any) => {
        return i === node.table.body.length || i === 1 ? 0.1 : 0.1;
      },
      vLineWidth: () => {
        return 0.1;
      },
      hLineColor: () => {
        return borderColor;
      },
      vLineColor: () => {
        return borderColor;
      },
      // hLineStyle: (i: number, node: any) => { return {dash: { length: 10, space: 4 }}; },
      // vLineStyle: (i: number, node: any) => { return {dash: { length: 10, space: 4 }}; },
      // paddingLeft: function(i, node) { return 4; },
      // paddingRight: function(i, node) { return 4; },
      // paddingTop: function(i, node) { return 2; },
      // paddingBottom: function(i, node) { return 2; },
      // fillColor: function (rowIndex, node, columnIndex) { return null; }
    };
  }

  public noContent() {
    return {
      text: 'No hay datos para mostrar',
      style: 'noData',
    };
  }

  public capitalizeText(text: any) {
    return text.split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
  }
}

export {
  BaseReport,
  generalTitleColor,
  lightFirstColumnColor,
  lightSecondColumnColor,
  lightThirdColumnColor,
  darkerLightFirstColumnColor,
  darkerLightSecondColumnColor,
  darkerLightThirdColumnColor,
  lightFourthColumnColor,
  darkerLightFourthColumnColor,
  lightGreenColor,
  lightRedColor,
  PAGE_MARGIN,
  darkBarChartColor,
  veryLightOrangeColor,
  darkerOrangeColor,
};
